import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../Pages/Home/Home'
import AboutUs from '../Pages/AboutUs/AboutUs'
import MarkdownPageMapper from '../Pages/Privacy/MarkdownPageMapper'
import NotFound from '../Pages/NotFound/NotFound'

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route
                path="/privacy"
                element={<MarkdownPageMapper contentType="privacy" />}
            />

            <Route
                path="/imprint"
                element={<MarkdownPageMapper contentType="imprint" />}
            />
            <Route
                path="/terms"
                element={<MarkdownPageMapper contentType="terms" />}
            />
            <Route
                path="/event-rules"
                element={<MarkdownPageMapper contentType="event-rules" />}
            />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

export default AppRoutes
